module.exports = __webpack_public_path__ + "img/tool.5caf7f2d.jpg";